import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import '../../assets/scss/generalStyles/_fonts.scss';
import { useNavigate } from 'react-router-dom';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Space, Table, Pagination } from 'antd';
import { DashboardPanelContext } from '../context/DashboardContext';
import { BSwalConfirmationDelete, BSwalDeleted, BSwalShowError } from '../../common/BSwal';
import { SET_VIEW_READ_ONLY } from '../context/reducer/actionTypes';
import { font } from '../configs/Variables';
import SlidingButton from '../buttons/Sliding';
import './table.css';
import useTable from './useTable';

const CustomTable = ({
  tableRef,
  columns = [],
  data,
  name,
  filtering = true,
  pageSize = 10,
  actions,
  title,
  createSlug,
  location,
  createAction,
  sortableColumns,
  onRowClick = false,
  key = 0,
  removePath = null,
  removeFunction = undefined,
  totalPages = 10,
  getOtherPageData = undefined,
}) => {
  const navigate = useNavigate();
  const { parentColumns, setParentColumns, count, setCount } = useTable({ columns });
  const { globalDispatch, removeItem } = useContext(DashboardPanelContext);

  const onPageChange = (current) => {
    getOtherPageData(current);
  };

  useEffect(() => {
    if (actions.length > 0) {
      setParentColumns(() => {
        const newState = [...columns];
        newState.push({
          title: 'عملیات',
          key: 'action',
          render: (_, record) => (
            <Space size='middle'>
              {actions[0] && (
                <EditOutlined
                  onClick={async () => {
                    if (globalDispatch) globalDispatch({ type: SET_VIEW_READ_ONLY, value: false });
                    navigate(`${actions[0]}${record.id}`);
                  }}
                />
              )}
              {actions[3] && onRowClick && (
                <EyeOutlined
                  onClick={async () => {
                    if (globalDispatch) globalDispatch({ type: SET_VIEW_READ_ONLY, value: true });
                    navigate(`${actions[3]}${record.id}`);
                  }}
                />
              )}
              {actions[1] && (
                <DeleteOutlined
                  onClick={async () => {
                    BSwalConfirmationDelete().then((result) => {
                      if (result.value) {
                        if (removePath) {
                          removeFunction(record.id);
                        } else {
                          removeItem(actions[1], record.id)
                            .then((response) => {
                              if (response) {
                                if (response.status === 204) {
                                  tableRef?.current?.onQueryChange();
                                  BSwalDeleted();
                                }
                                window.location.reload();
                                if (response.status === 409) {
                                  BSwalShowError(get(response, 'data.messages', []));
                                }
                              }
                            })
                            .finally();
                        }
                      }
                    });
                  }}
                />
              )}
            </Space>
          ),
        });
        return [...newState];
      });
      setCount(count + 1);
    }
  }, []);
  return (
    <>
      <Table
        id={name}
        columns={parentColumns}
        dataSource={data}
        key={count + key}
        tableRef={tableRef}
        title={() => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h1 style={{ margin: 0, fontFamily: font, fontSize: 15 }}>{title}</h1>
            {actions[2] && createSlug && createAction && (
              <SlidingButton
                style={{ marginRight: 25, marginLeft: 25 }}
                label={createSlug}
                location={location}
                onClick={createAction}
                id='newItem'
              />
            )}
          </div>
        )}
        sorter={sortableColumns}
        filterSearch={filtering}
        pagination={false}
      />
      <br />
      <Pagination onChange={onPageChange} defaultCurrent={1} total={totalPages} />
    </>
  );
};

Table.propTypes = {
  tableRef: PropTypes.any,
  columns: PropTypes.array.isRequired,
  data: PropTypes.func.isRequired,
  name: PropTypes.string,
  filtering: PropTypes.bool,
  pageSize: PropTypes.number,
  actions: PropTypes.array,
  title: PropTypes.string,
  createSlug: PropTypes.string,
  location: PropTypes.any,
  createAction: PropTypes.func,
  sortableColumns: PropTypes.bool,
};

export default CustomTable;
